import * as React from 'react';
import { Icon, Popover } from 'grab-ui';
import 'components/form/trident-campaigns/WidgetComponent.scss';

interface Props {
  icon ?: string,
  content: string,
  limit: number,
  usage: number,
}

const LimitHitWarning = (prop: Props) => {
  const defaultIcon = 'exclamation-02';
  return (
    prop.limit != 0 && prop.usage >= prop.limit && <Popover
      content={
        <div style={{ padding: '10px' }}>
          {prop.content}
        </div>
      }
    >
      <div>
        <Icon type={`grabicon-${prop.icon ? prop.icon : defaultIcon}`} className="widgetInfoStyle" />
      </div>
    </Popover>
  );
};

export default LimitHitWarning;
